export function createHomeGatewayPreferencesRepository(supabase) {
  return {
    async read(userId) {
      const { data, error } = await supabase.schema('public').from('home_gateway_preferences')
        .select('tiles,shelves').eq('user_id', userId).maybeSingle()
      if (error) throw error
      return data
    },
    async write(userId, preferences) {
      const { data, error } = await supabase.schema('public').from('home_gateway_preferences')
        .upsert({ user_id: userId, ...preferences }, { onConflict: 'user_id' })
        .select('tiles,shelves').single()
      if (error) throw error
      return data
    },
  }
}
